import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from "@angular/router";
import { loadingFade } from '../../animacoes';
import { NgOption } from '@ng-select/ng-select';

import { AuthService } from '../services/auth.service';
import { DespesaService } from '../services/despesa.service';
import { ProfissionalService } from '../services/profissional.service';
import { FornecedorService } from '../services/fornecedor.service';
import { PostoService } from '../services/posto.service';
import { VeiculoService } from '../services/veiculo.service';
import * as Datepicker from 'js-datepicker';
import * as moment from 'moment';
import Swal from 'sweetalert2';
import { ClienteService } from '../services/cliente.service';
import { UnidadeService } from '../services/unidade.service';

@Component({
	selector: 'app-combustivel-edit',
	templateUrl: './combustivel-edit.component.html',
	styleUrls: ['./combustivel-edit.component.css'],
	animations: [loadingFade]
})

export class CombustivelEditComponent implements OnInit {
	public loading;
	public submitting = false;
	public despesa_id = null;
	public agencias = [];
	public unidades = [];
	public tipo_combustivel = [
		{ tipo_combustivel_id: 'A', tipo_combustivel_nome: "Álcool" },
		{ tipo_combustivel_id: 'G', tipo_combustivel_nome: "Gasolina" },
		{ tipo_combustivel_id: 'D', tipo_combustivel_nome: "Diesel" }
	];

	public formDespesa: FormGroup;
	public tipo_despesa_array = [];
	public veiculo_array: NgOption[] = [];
	public fornecedor_array = [];
	public postos = [];
	public unidade_medida_array = [];
	public despesa_solicitante_array = []
	public situacao_array = [
		{despesa_situacao_id: 'A', despesa_situacao_nome: 'Situação A'},
		{despesa_situacao_id: 'B', despesa_situacao_nome: 'Situação B'}
	];

	public qtde_char_descricao = 0;

	// datepickers
	public data_compra_dp;

	//filtro
	public cliente_id___cliente_id = null; 
	public unidade_id___unidade_id = null;
	public veiculo_id___veiculo_id = null;
	public despesa_data_compra___data_i = null;
	public despesa_data_compra___data_f = null;
	public despesa_valor___valorMin = null;	
	public despesa_valor___valorMax = null;

	constructor(private authSvc: AuthService,
				private route: ActivatedRoute,
				private fb: FormBuilder,
				private despesaSvc: DespesaService,
				private fornecedorSvc: FornecedorService,
				private postoSvc: PostoService,
				private profSvc: ProfissionalService,
				private router: Router,
				private clienteSvc: ClienteService,
				private unidadeSvc: UnidadeService,
				private veiculoSvc: VeiculoService) { }

	ngOnInit() {
		this.criaForm();
		this.pegaAgencias();
		this.loading = true;

		this.route.params.subscribe( params => {
			if (params.id) {



				var splitFiltro = params.id.split("?");

				if(splitFiltro[1] !== undefined){
				  
				  var splitfiltro = splitFiltro[1].split("&");
				  for (let f in splitfiltro) {
		
					var loSplitValor = splitfiltro[f].split("=");
		
					switch(loSplitValor[0]) { 
					  case "cliente_id___cliente_id": { 
						 this.cliente_id___cliente_id = loSplitValor[1];
						 break; 
					  } 
					  case "unidade_id___unidade_id": { 
						this.unidade_id___unidade_id = loSplitValor[1];
						 break; 
					  } 
					  case "veiculo_id___veiculo_id": { 
						this.veiculo_id___veiculo_id = loSplitValor[1];
						 break; 
					  } 
					  case "despesa_data_compra___data_i": { 
						this.despesa_data_compra___data_i = loSplitValor[1];
						 break; 
					  }      
					  case "despesa_data_compra___data_f": { 
						this.despesa_data_compra___data_f = loSplitValor[1];
						 break; 
					  }      
					  case "despesa_valor___valorMin": { 
						this.despesa_valor___valorMin = loSplitValor[1];
						 break; 
					  } 
					  case "despesa_valor___valorMax": { 
						this.despesa_valor___valorMax = loSplitValor[1];
						 break; 
					  }                                                             
				   }
		
				  }
		
		
				}     

				this.despesa_id = params.id;
				// pega dados a partir do id
				this.despesaSvc.getDespesa(params.id).then((data: any) => {
					let data_compra = null
					this.pegaUnidades(data.cliente_id)
					this.getSolicitantes(data.cliente_id)

					if (moment(data.despesa_data_compra).isValid()) {
						let moment_date = moment(data.despesa_data_compra, 'YYYY-MM-DD');
						data_compra = moment_date.format('DD/MM/YYYY');
						this.data_compra_dp.setDate(moment_date.toDate());
					}

					this.preencheForm({
						despesa_id: data.despesa_id,
						usuario_id: this.authSvc.getUsuarioId(),
						unidade_id: data.unidade_id,
						cliente_id: data.cliente_id,
						veiculo_id: data.veiculo_id,
						posto_id: data.posto_id,
						despesa_valor: data.despesa_valor,
						despesa_data_compra: data_compra,
						despesa_descricao: data.despesa_descricao,
						despesa_solicitante_id: data.despesa_solicitante_id,
						despesa_aprovador: data.despesa_aprovador,
						despesa_quantidade: data.despesa_quantidade,
						tipo_combustivel_id: data.flag_tipo_combustivel,
					});

					if (data.despesa_descricao)
						this.qtde_char_descricao = data.despesa_descricao.length;

					this.loading = false;
				});
			}
			else {
				this.loading = false;
			}
		});
	}

	criaForm() {
		this.formDespesa = this.fb.group({
			despesa_id: null,
			usuario_id: this.authSvc.getUsuarioId(),
			unidade_id: '',
			cliente_id: '',
			veiculo_id: [null, Validators.required],
			posto_id: [null, Validators.required],
			despesa_valor: ['', Validators.required],
			despesa_data_compra: [null, Validators.required],
			despesa_descricao: ['', Validators.maxLength(200)],
			despesa_aprovador: ['', Validators.maxLength(100)],
			despesa_quantidade: [null],
			tipo_combustivel_id: '',
			despesa_solicitante_id: ''
		});

		this.pegaVeiculos();
		this.pegaPostos();
		moment.locale('pt-Br');
		this.data_compra_dp = Datepicker('#despesa_data_compra', {
			customMonths: moment.months(),
			customDays: moment.weekdaysShort(),
			overlayPlaceholder: 'Preencha o ano',
			overlayButton: 'Enviar',
			formatter: (element, date) => {
				let formatted = moment(date).format('DD/MM/YYYY');
				this.formDespesa.controls['despesa_data_compra'].setValue(formatted);
			}
		});
	}

	pegaVeiculos() {
		this.veiculoSvc.getVeiculosActiveByUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
			let dados = [];
			for(let veiculo of data){
				dados.push({
					veiculo_id: veiculo.veiculo_id,
					veiculo_label: veiculo.veiculo_placa + ' - ' + veiculo.veiculo_numero,
					unidade_id: veiculo.unidade_id,
					cliente_id: veiculo.cliente_id
				});
			}
			this.veiculo_array = dados;
		}).catch((err) => {
			console.log(err)
		});
	}

	pegaPostos() {
		this.postoSvc.getPostos().then((data: any[]) => {
			this.postos = data;
		}).catch((err) => {
			console.log(err);
		});
	}

	preencheForm(dados) {
		this.formDespesa.setValue(dados);
	}

	onChangeVeiculo(e) {
		/*this.formDespesa.controls['unidade_id'].setValue(e.unidade_id);
		this.formDespesa.controls['cliente_id'].setValue(e.cliente_id);

		this.onChangeAgencia(e)*/
	}


	enviaDespesa() {
		if (this.formDespesa.valid) {
			this.submitting = true;

			let toSend = this.formDespesa.value;
			toSend['grupo_despesa_id'] = 2;
			console.log('toSend', toSend)
			if (this.despesa_id === null) { // criar
				this.despesaSvc.criaCombustivel(toSend).then((data) => {
					console.log('resp', data);
					Swal.fire({
						type:'success',
						title:'Despesa cadastrada com sucesso!',
						onClose:() => {
							this.router.navigate(['home/combustivel']);
						}
					});
				}).catch(err => {
					console.log(err);
					this.submitting = false;
					Swal.fire({
						type:'error',
						title:'Ops! Algo de errado aconteceu!',
						text: 'Tente novamente mais tarde.'
					});
				});
			}
			else { // editar
				this.despesaSvc.editaCombustivel(toSend).then((data) => {
					console.log('resp', data);
					Swal.fire({
						type:'success',
						title:'Despesa alterada com sucesso!',
						onClose:() => {
							this.router.navigate(['home/combustivel']);
						}
					});
				}).catch(err => {
					console.log(err);
					this.submitting = false;
					Swal.fire({
						type:'error',
						title:'Ops! Algo de errado aconteceu!',
						text: 'Tente novamente mais tarde.'
					});
				});
			}
		}
		else{
			for( let field in this.formDespesa.controls){
				let campo = this.formDespesa.get(field);
				campo.markAsTouched();
			}
			this.submitting = false;
			Swal.fire({
				type:'error',
				title:'Atenção!',
				text: 'Verifique os campos obrigatórios e tente novamente.'
			});
		}
	}

	onKeyUpDescricao(e) {
		this.qtde_char_descricao = this.formDespesa.value.despesa_descricao.length;
	}

	invalid(nome) {
		let input = this.formDespesa.get(nome);
		return input.touched && input.invalid;
	}

	verificaCliente() {
		if (this.formDespesa.get('cliente_id').value)
			this.formDespesa.get('unidade_id').enable();
		else
			this.formDespesa.get('unidade_id').disable();
	}

	onChangeAgencia(e){
		this.formDespesa.controls.unidade_id.setValue(null);
		this.formDespesa.controls.veiculo_id.setValue(null);
		this.formDespesa.controls.posto_id.setValue(null);
		this.formDespesa.controls.despesa_solicitante_id.setValue(null);

		this.verificaCliente();
		this.getSolicitantes(e.cliente_id);
		this.onChangePosto(e);

		this.unidadeSvc.getUnidadesByUsuarioAndCliente(this.authSvc.getUsuarioId(), e.cliente_id).then((data: any) => {
			this.unidades = data;
		}).catch((err) => {
		  console.log(err);
		});
	  }

	  pegaUnidades(cliente_id){
		this.unidadeSvc.getUnidadesByUsuarioAndCliente(this.authSvc.getUsuarioId(), cliente_id).then((data: any) => {
			this.unidades = data;
		}).catch((err) => {
		  console.log(err);
		});
	  }
	  

	  onChangeUnidade(e){
		//console.log(e);
		this.veiculoSvc.getByTipoVeiculo(e.unidade_id, 1).then((data: any[]) => {
		  //this.veiculo_array = data;
			}).catch((err) => {
				console.log(err);
			});
	  }

	  onChangePosto(e){
		this.postoSvc.getPostoPorCliente(e.cliente_id).then((data: any[]) => {
			this.postos = data;
		}).catch((err) => {
			console.log(err);
		});
	  }	  

	  onChangeVeiculoUnidade(e){
		this.veiculo_array = []
		this.veiculoSvc.getByVeiculoClienteUnidade(e.unidade_id,e.cliente_id).then((data: any[]) => {

			let dados = [];
			for(let veiculo of data){
				dados.push({
					veiculo_id: veiculo.veiculo_id,
					veiculo_label: veiculo.veiculo_placa + ' - ' + veiculo.veiculo_numero,
					unidade_id: e.unidade_id,
					cliente_id: e.cliente_id
				});
			}

			this.veiculo_array = dados;


			  }).catch((err) => {
				  console.log(err);
			  });
	  }

	  pegaAgencias(){
		this.clienteSvc.getClientesByUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
		  this.agencias = data;
		}).catch((err) => {
		  console.log(err);
		});
	  }

	  getSolicitantes(cliente){

		this.clienteSvc.getSolicitanteClientesByUsuario(cliente).then((data: any) => {

		  let dados = [];
		  for(let solicitante of data){
			  dados.push({
				  despesa_solicitante_id: solicitante.usuario_id,
				  despesa_solicitante_nome: solicitante.usuario_nome
			  });
		  }
		  this.despesa_solicitante_array = dados;

		}).catch((err) => {
		  console.log(err);
		});
	  }	  


	  onClickVoltar(){

		let params = 'cliente_id___cliente_id=' + this.cliente_id___cliente_id;
		params += "&unidade_id___unidade_id=" + this.unidade_id___unidade_id;
		params += "&veiculo_id___veiculo_id=" + this.veiculo_id___veiculo_id;
		params += "&despesa_data_compra___data_i=" + this.despesa_data_compra___data_i;
		params += "&despesa_data_compra___data_f=" + this.despesa_data_compra___data_f;
		params += "&despesa_valor___valorMin=" + this.despesa_valor___valorMin;
		params += "&despesa_valor___valorMax=" + this.despesa_valor___valorMax;
	
		this.router.navigate(['/home/combustivelfiltro/' + params]);
	
	  }
  
	
}
